export const GET_PACKAGE_BOXES_SUCCESS = 'GET_PACKAGE_BOXES_SUCCESS';
export const GET_PACKAGE_BOXES_REQUEST = 'GET_PACKAGE_BOXES_REQUEST';
export const GET_PACKAGE_BOXES_FAILURE = 'GET_PACKAGE_BOXES_FAILURE';
export const getPackageBoxesSuccess = (payload) => ({
    type: GET_PACKAGE_BOXES_SUCCESS,
    payload,
});
export const getPackageBoxesRequest = () => ({
    type: GET_PACKAGE_BOXES_REQUEST,
});
export const getPackageBoxesFailure = (payload) => ({
    type: GET_PACKAGE_BOXES_FAILURE,
    payload,
});
